import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../../partials/LoadingSpinner';
import PageHeader from '../../partials/PageHeader';

import ThresholdList from './ThresholdList';
import ThresholdSearch from './ThresholdSearch';
import ThresholdUpload from './ThresholdUpload';

import { locationsIndex } from '../../../redux/actions/locations';

const Thresholds = ({ payload, locations, loadLocations, thresholds }) => {
  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState('view');

  useEffect(() => {
    if(thresholds.status === 'created') {
      setActiveTab('view');
    }
  }, [thresholds]);

  useEffect(() => {
    loadLocations(payload);
  }, []);

  return(
    <>
      <PageHeader stripeBackground='#5bc6cc' helpLink="ecwid/set-suggestion-thresholds-2/" />
      <div className="settings-page cf">
        <div className="settings-page__header">

          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Thresholds</div>
              </div>
              <div className="named-area__description">
                <p>Set inventory target thresholds for your store.</p>
                <p>When suggesting purchase orders, your store's on hand inventory added with incoming inventory from open purchase orders, and compare that to the low and critical inventory thresholds created here.</p>
                <p>Critically low inventory levels will show red when viewing suggested purchase order lines.</p>
              </div>
            </div>
            <div className="named-area__body">
              <div className="a-card-stack">
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                    <div className="graphic-radio-group">
                      <div className="graphic-radio-group__items">

                        <div className="graphic-radio graphic-radio--small">
                          <label className="graphic-radio__label">
                            <input 
                              type="radio"
                              name="tab"
                              value="view"
                              className="graphic-radio__input"
                              checked={activeTab === "view"}
                              onChange={ () => setActiveTab('view') }
                            />
                            <div className="graphic-radio__icon">
                              <span className="svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M15 2H3v14h12ZM3 0a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" fill="currentColor" fill-rule="evenodd"/><path d="M5 5.5a1 1 0 0 1 1-1h6c1.33 0 1.33 2 0 2H6a1 1 0 0 1-1-1ZM6 8h6a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2ZM5 12.5a1 1 0 0 1 1-1h6c1.33 0 1.33 2 0 2H6a1 1 0 0 1-1-1z" fill="currentColor"/></svg>
                              </span>
                              <div className="graphic-radio__bg"></div>
                            </div>
                            <span className="graphic-radio__title">Manage Existing Thresholds</span>
                          </label>
                        </div>

                        <div className="graphic-radio graphic-radio--small">
                          <label className="graphic-radio__label">
                            <input 
                              type="radio"
                              name="tab"
                              value="create"
                              className="graphic-radio__input"
                              checked={activeTab === "create"}
                              onChange={ () => setActiveTab('create') }
                            />
                            <div className="graphic-radio__icon">
                              <span className="svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 7c0 3.866-3.134 7-7 7-1.5724 0-3.0236-.5184-4.1922-1.3936l-4.1007 4.1007c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3906-.3905-1.0237 0-1.4143l4.1007-4.1007C4.5184 10.0236 4 8.5723 4 7c0-3.866 3.134-7 7-7s7 3.134 7 7zm-2 0c0 2.7614-2.2386 5-5 5S6 9.7614 6 7s2.2386-5 5-5 5 2.2386 5 5z"/></svg>
                              </span>
                              <div className="graphic-radio__bg"></div>
                            </div>
                            <span className="graphic-radio__title">Search Products and Manage Thresholds</span>
                          </label>
                        </div>

                        <div className="graphic-radio graphic-radio--small">
                          <label className="graphic-radio__label">
                            <input 
                              type="radio"
                              name="tab"
                              value="upload"
                              className="graphic-radio__input"
                              checked={activeTab === "upload"}
                              onChange={ () => setActiveTab('upload') }
                            />
                            <div className="graphic-radio__icon">
                              <span className="svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 11a4 4 0 0 1-4 4H4.5a4.5 4.5 0 0 1-1.214-8.834 6.002 6.002 0 0 1 11.648.944A4.002 4.002 0 0 1 18 11zm-4-3a3 3 0 0 1 0 6H4.5a3.5 3.5 0 0 1-1.442-6.69.5.5 0 0 0 .99-.004 4.988 4.988 0 0 1 .051-.302 5.002 5.002 0 0 1 9.803.006A.5.5 0 0 0 14 8z" fill="currentColor"/></svg>
                              </span>
                              <div className="graphic-radio__bg"></div>
                            </div>
                            <span className="graphic-radio__title">Upload Thresholds CSV</span>
                          </label>
                        </div>

                      </div>
                    </div>

                    { activeTab === 'view' &&
                      <ThresholdList
                        payload={payload}
                      />
                    }
                    { activeTab === 'create' &&
                      <ThresholdSearch
                        payload={payload}
                      />
                    }
                    { activeTab === 'upload' &&
                      <ThresholdUpload
                        payload={payload}
                      />
                    }
              
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  locations: state.locations,
  thresholds: state.thresholds,

});

const mapDispatchToProps = (dispatch) => ({
  loadLocations: (payload) => dispatch(locationsIndex(payload)),

});

export default connect(mapStateToProps, mapDispatchToProps)(Thresholds);
